import * as React from 'react';
import Typography from '@mui/material/Typography';
import {Container, Paper } from '@mui/material';
import aboutUsContent from './about-us.json';
import FooterSection from '../landing/sections/FooterSection';
import '../landing/LandingPage.css';
import Header from '../../pages/login-register/components/header';

const paperStyle = {
  bgcolor: 'background.paper',
  p: 4,
  mb: 4,
  mt: 2,
  borderRadius: 2,
  boxShadow: 2,
};

const renderContentWithBold = (content) => {
  const parts = content.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <span key={index} style={{ fontWeight: 700 }}>{part.slice(2, -2)}</span>;
    }
    return part;
  });
};

const renderContent = (content) => {
  return content.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {renderContentWithBold(line)}
      {index < content.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));
};

export default function AboutUs() {
  return (
      <div className="landing-page">
      <Header showIntro={true} showLogin={true} />
        <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
        {/* Privacy Policy */}
        <Paper sx={paperStyle} id="about-us">
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {aboutUsContent.aboutUs.title}
          </Typography>
          <Typography sx={{ mt: 2 }}>
            {renderContent(aboutUsContent.aboutUs.content)}
          </Typography>
        </Paper>
      </Container>
    <FooterSection />
    </div>

  );
}